import { Command } from "prosemirror-state";
import {UiCommand} from "@fd/editors/html/EditorSupport.ts";
import {FormDefinition, FormDefinitions} from "@t/fd/layout/FormDefinition.ts";
import type {FormPartOrReference} from "@t/fd/FormPartOrReference.ts";
import {FormEnvironment} from "@fd/Types.ts";
import {Widgets} from "@t/fd/layout/Widgets.ts";
import type {Widget} from "@t/fd/layout/Widget.ts";
import {Selection} from "prosemirror-state";
import {InterfaceRoot} from "@t/fd/InterfaceRoot.ts";

export function removeLinkCommand(): Command {
	return (state, dispatch) => {
		const linkType = state.schema.marks.link;
		if (!linkType) return false;

		const { from, to } = state.selection;
		const tr = state.tr;

		// Remove all link marks within the selection
		state.doc.nodesBetween(from, to, (node, pos) => {
			if (node.isText && node.marks.some(mark => mark.type === linkType)) {
				tr.removeMark(pos, pos + node.nodeSize, linkType);
			}
		});

		if (dispatch) dispatch(tr);
		return true;
	};
}

export interface LinkData {
	href: string;
}

export function addLinkCommand(env:FormEnvironment):UiCommand<LinkData> {
	return {
		extract(state): LinkData {
			return { href: "https://www.anneca.cz" };
		},

		form: <InterfaceRoot<FormDefinition>>{
			type: "interface",
			version: 2,
			lists: {},
			categories: {},
			define: {},
			methods: {},
			content: <FormDefinition>{
				type: "form",
				headerIcon: "link",
				headerTitle: env.msg("editor.tooltip.link"),
				body: <Widgets>{
					type: "widgets",
					items: [
						<Widget>{
							type: "widget",
							display: "standard",
							label: {
								type: "text",
								value: env.msg("bulkMailLink.url"),
							},
							field: {
								type: "input",
								itype: "url",
								property: "href",
								tabindex: 10
							},
							catch: "href"
						}
					]
				},
				initialWidth: 400
			}
		},

		prepare(data: LinkData, savedSelection?:any):Command {
			return (state, dispatch) => {
				const linkType = state.schema.marks.link;
				if (!linkType) return false;

				const tr = state.tr;
				if (savedSelection) {
					const s = Selection.fromJSON(tr.doc, savedSelection);
					tr.setSelection(s)
				}
				tr.addMark(state.selection.from, state.selection.to, linkType.create(data));
				if (dispatch) dispatch(tr);
				return true;
			};
		}
	};
}